import { RefObject } from 'react';
import { RegistryForm } from 'src/types/backendContent/RegistryForm';
import { Form, FormBaseProps, FormForEnum } from 'src/uikit/Form';

type RegistryFormProps = RegistryForm & {
  formRef: RefObject<HTMLDivElement>;
  multipleComment: FormBaseProps['multipleComment'];
};

export function RegistryFormBlock(props: RegistryFormProps) {
  const {
    formRef,
    buttonTitle,
    description,
    title = 'Связаться с нашим специалистом',
    successText,
    failedText,
    multipleComment,
    fields,
  } = props;

  return (
    <Form
      id="form"
      ref={formRef}
      inputPath="v2/order"
      formFor={FormForEnum.Registry}
      title={title}
      subtitle={description}
      buttonTitle={buttonTitle}
      fields={fields}
      multipleComment={multipleComment}
      successNotice={{
        title: successText,
      }}
      errorNotice={{
        title: failedText,
      }}
      allFormsSentFormType="sale"
      analyticsFieldFill={{ formType: 'body' }}
      formVariant="inner"
      successfulSubmissonFormAnalytics={{
        formname: 'lead-solutions',
      }}
    />
  );
}
